import { matchPath } from 'react-router-dom';

import { combineEpics } from 'redux-observable';
import { EMPTY, Observable } from 'rxjs';
import { filter, switchMap, withLatestFrom } from 'rxjs/operators';
import { isActionOf } from 'typesafe-actions';

import { AppRoutes } from 'AppRoutes';
import { selectSelectedProvider } from 'rdx/account';
import { GlobalAppActions, routeChangeAction } from 'rdx/actions';
import { AppServices } from 'rdx/middleware';
import { GlobalAppState } from 'rdx/state';

import {
  getMixpanelExtraParams,
  MixpanelExtraParams,
} from '@provider-portal/common/utils/getMixpanelExtraParams';
import { MixpanelEventType } from '@provider-portal/common/services/MixpanelService';

const trackMixpanelEventsOnRouteChangeEpic = (
  action$: Observable<GlobalAppActions>,
  state$: Observable<GlobalAppState>,
  { mixpanelService }: AppServices,
): Observable<GlobalAppActions> => {
  return action$.pipe(
    filter(isActionOf(routeChangeAction)),
    withLatestFrom(state$),
    switchMap(([action, state]) => {
      const { pathname, search, state: locationState } = action.payload.location;

      if (pathname) {
        Object.values(AppRoutes).forEach((path) => {
          const match = matchPath(pathname, {
            path,
            exact: true,
            strict: true,
          });

          if (match) {
            const providerId = selectSelectedProvider(state)?.providerId;
            const extraParams: MixpanelExtraParams = getMixpanelExtraParams('', search);
            mixpanelService.trackAccountEvent(MixpanelEventType.NAVIGATION_PATH_CHANGE, {
              ...(providerId ? { providerId } : {}),
              path: match.path,
              state: locationState,
              ...match.params,
              ...extraParams,
            });
          }
        });
      }

      return EMPTY;
    }),
  );
};

export const analyticEpic = combineEpics(trackMixpanelEventsOnRouteChangeEpic);
